/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All DXP external links.
 * @export
 */
export const DXP_EXTERNAL_LINKS = {
  connectProductPage: `https://www.squiz.net/connect`,
  customerSuggestions: `https://squizpm.canny.io/squiz-dxp`,
  datastoreProductPage: `https://www.squiz.net/datastore`,
  funnelbackProductPage: `https://www.squiz.net/funnelback`,
  helpCenter: `https://help.squiz.net/`,
  marketplace: `https://marketplace.squiz.net/`,
  matrixProductPage: `https://www.squiz.net/matrix`,
  mySquiz: `https://my.squiz.net/`,
  squizAcademy: `https://academy.squiz.net/`,
  userDocumentation: `https://docs.squiz.net/squiz-dxp/`,
  userDocumentationRoles: `https://docs.squiz.net/squiz-dxp/latest/administration/user-roles/index.html`,
};
